import React, { useState } from 'react'
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent'
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent'
import BtnWhite from '../../../Shared/Buttons/BtnWhite'
import ServiceButtons from '../../../Shared/ServiceButtons/ServiceButtons';
import Config from '../../../../Config';


function IdfOrderPopUp({ goToSalePage }) {

  const [isIdfOrder, setIsIDFOrder] = useState(false)

  return (
    <div className='idfOrderPopUp'>
      {!isIdfOrder ?
        <>
          <PopupImageComponent icon={require('./images/lampIcon/lamp.svg')} />
          <PopupHeadlineComponent title={'רגע לפני שטסים,<br/>האם מדובר בנסיעה בתפקיד?'} />
          <BtnWhite onclick={() => setIsIDFOrder(true)} text={'נסיעה בתפקיד'} />
          <BtnSubmit onclick={() => goToSalePage()} text={'נסיעה פרטית'} />
        </>
        :
        <>
          <PopupImageComponent icon={require('./images/icon-error/icon-120-error.svg')} />
          <PopupHeadlineComponent title={'עליך לפנות לקצין/ה הקשר היחידתי <br/> שלך להמשך תהליך רכישת החבילה'} />
          <ServiceButtons whatsappUrl={Config.idfWhatsAppLink} />
        </>
      }
    </div>
  )
}



export default IdfOrderPopUp;
